<div class="about-page-wrapper"
     fxLayout="row"
     fxLayoutAlign="center center">
  <div class="about-page-container" fxLayout="column" style="padding: 0 1em" fxFlex.lt-md="100" fxFlex="65">
    <h1>{{ 'ABOUT.TITLE' | translate }}</h1>
    <p>
      {{ 'ABOUT.PARAGRAPH_1' | translate }}
      <br/>
      <br/>
      {{ 'ABOUT.PARAGRAPH_2' | translate }}
      <br/>
      <br/>
      {{ 'ABOUT.PARAGRAPH_3' | translate }}

      <br/>    <br/>    <br/>    <br/>

      {{ 'ABOUT.PARAGRAPH_4' | translate }}
      <br/>    <br/>


      {{ 'ABOUT.PARAGRAPH_5' | translate }}
    </p>
  </div>
</div>
